import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import _get from 'lodash/get';
import _filter from 'lodash/filter';
import _uniqBy from 'lodash/uniqBy';
import SelectField from './select-field';
import { myGroupsQuery } from '../../apollo/groups';
import { useAppContext } from '../../contexts/app';

const GroupField = ({ permission, group, ...rest}) => {
  const { isLoggedIn } = useAppContext();

  const { data: groupsData } = useQuery(myGroupsQuery, {
    skip: !isLoggedIn,
  });

  const groups = useMemo(() => {
    if (!groupsData) {
      return [];
    }
    return _filter(_get(groupsData, 'me.groups', []), `permissions.${permission}`);
  }, [groupsData]);

  const options = useMemo(() => {
    const array = group ? [{ value: group.id, label: group.name }] : [];
    if (!groups) {
      return array;
    }
    return _uniqBy([
      ...array,
      ...groups.map((g) => ({
        value: g.id,
        label: g.name,
      })),
    ], 'value');
  }, [groups, group]);

  return (
    <SelectField
      {...rest}
      options={options}
    />
  );
};

GroupField.propTypes = {
  permission: PropTypes.oneOf(['createEvent', 'createPost', 'uploadImage']),
  group: PropTypes.object,
},

GroupField.defaultProps = {
  permission: 'createEvent',
};

export default GroupField;
